<template>
    <div>
        
        <MouthSmell />
    </div>
</template>

<script>

import MouthSmell from '../blog-details/MouthSmell.vue'

export default {
    components: {
      
        MouthSmell,
    }
}
</script>